<template>
  <span
    ref="tokenContainer"
    class="rtb-popover-container"
  >
    <SearchableDropdown
      v-model="selectedTag"
      class="filter-comparison-type bulk-modifier-dropdown"
      rules="required"
      :config="bulkTagOptions"
      :placeholder="$t('SELECT_BULK_MODIFIER_PH')"
      :searchable="true"
      :clearable="false"
      @change="onSelectedBulkModifier"
    />
    <InputFile
      v-tooltip="$t('SELECT_BULK_MODIFIER_BUTTON_TT')"
      accept=".csv,.txt"
      :show-file-name="false"
      @change="onFileUpload"
    />
  </span>
</template>

<script>
import { mapState, mapActions} from 'vuex';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import InputFile from '@/core/components/Form/InputFile';
import messages from './locales';
import sharedMessages from '@/core/locales';
import { getStatus, STATUS_ERROR, STATUS_SUCCESS } from '@/store/helpers';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  components: { SearchableDropdown, InputFile },
  props: {
    selectedBulkModifierId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedTag: this.selectedBulkModifierId
    };
  },
  computed: {
    ...mapState('dynamicInboundCalls', ['bulkModifiers']),
    ...mapState('dynamicInboundCalls', {
      uploadBulkModifiersStatus: (state) => getStatus(state, 'uploadBulkModifiers')
    }),
    bulkTagOptions() {
      return {
        options: this.bulkModifiers,
        placeholder: this.$t('BULK_MODIFIER_SELECT_PH'),
        clearable: false,
        reduce: (option) => option.id,
        label: 'name',
      };
    },
  },
  watch: {
    selectedBulkModifierId: function (newVal) {
      // watch it
      this.selectedTag = newVal;
    },
  },
  methods: {
    ...mapActions('dynamicInboundCalls', ['uploadBulkModifiers']),
    onSelectedBulkModifier(bulkModifier) {
      this.$emit('selected', bulkModifier);
    },
    async onFileUpload(file) {
      await this.uploadBulkModifiers({file});
      if (this.uploadBulkModifiersStatus.status === STATUS_ERROR) {
        utilities.showToaster(STATUS_ERROR, this.uploadBulkModifiersStatus.error);
      }
      if (this.uploadBulkModifiersStatus.status === STATUS_SUCCESS) {
        this.$emit('selected', this.uploadBulkModifiersStatus.uploadedListId);
        utilities.showToaster(STATUS_SUCCESS, this.$t('BULK_LIST_UPLOAD_SUCCESS_TOAST'));
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style scoped>
.rtb-popover-container{
  display: flex;
}
.bulk-modifier-dropdown {
  flex: 1;
}
</style>